import React from 'react';
import { ArrowRightIcon, XIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
import { useLanguage } from '../../contexts/LanguageContext';
export function Pain() {
  const {
    t
  } = useLanguage();
  return <section className="bg-mist py-24 sm:py-32" aria-labelledby="pain-heading" data-id="element-238" data-mp="2du634xo3p7i3">
      <div className="mx-auto max-w-shell px-5 sm:px-8" data-id="element-239" data-mp="2hwsyv9nw7ckk">
        <Reveal data-id="element-240" data-mp="2hu7uoe04gkjn">
          <h2 id="pain-heading" className="headline mx-auto max-w-[720px] text-center text-[32px] font-bold text-ink sm:text-[46px]" data-id="element-241" data-mp="2mvx7nz6wn8ad">
            {t.pain.heading}
          </h2>
        </Reveal>

        <ul className="mt-14 grid gap-6 md:grid-cols-3" data-id="element-242" data-mp="2wlgoz0eyyu34">
          {t.pain.cards.map((pain, i) => <Reveal as="li" key={pain.title} delay={i * 0.1} data-id="element-243" data-mp="2wnt8vj4afeit" data-mpi={i}>
              <div className="group h-full rounded-3xl border border-ink/[0.07] bg-white p-8 shadow-soft transition-all duration-300 hover:-translate-y-1.5 hover:border-brand/25 hover:shadow-lift" data-id="element-244" data-mp="31k0etbwooq0r">
                <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-brand/10 transition-colors duration-300 group-hover:bg-brand" data-id="element-245" data-mp="3alrjcdfhmqt1">
                  <XIcon className="h-5 w-5 text-brand transition-colors duration-300 group-hover:text-white" aria-hidden="true" data-id="element-246" data-mp="1wmzv8pxmgnx5" />
                </span>
                <h3 className="mt-6 text-[19px] font-semibold tracking-tight text-ink" data-id="element-247" data-mp="1rnx1w2r08650">{pain.title}</h3>
                <p className="mt-3 text-[15px] leading-relaxed text-ink/60" data-id="element-248" data-mp="1mqeo9z21l2qo">{pain.body}</p>
              </div>
            </Reveal>)}
        </ul>

        <Reveal delay={0.15} data-id="element-249" data-mp="2fdhiiezoqrb4">
          <div className="mt-14 flex flex-col items-center gap-7" data-id="element-250" data-mp="2fekbcsgkj3to">
            <p className="max-w-[620px] text-center text-[19px] font-medium leading-relaxed text-ink sm:text-[22px]" data-id="element-251" data-mp="2alzknzsyl6ud">
              {t.pain.bottom}
            </p>
            <a href="#consultation" className="group inline-flex items-center gap-2 rounded-2xl bg-ink px-7 py-4 text-[15px] font-semibold text-white shadow-lift transition-all duration-300 hover:-translate-y-0.5 hover:bg-ink-800" data-id="element-252" data-mp="25lbufgck0u17">
              {t.pain.cta}
              <ArrowRightIcon className="h-[18px] w-[18px] transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" data-id="element-253" data-mp="wfmfe8yq084c" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>;
}